import { lazy, Suspense, type ComponentProps } from "react";

const Waves = lazy(() => import("./Waves"));

export function WavesLazy(props: ComponentProps<typeof Waves>) {
  return (
    <Suspense fallback={<div className="absolute inset-0 bg-background" />}>
      <Waves {...props} />
    </Suspense>
  );
}

export default WavesLazy;